import { connect } from 'react-redux';
import { getGoalsChartList, receiveData } from '../../EducationChart/EducationChartActions';
import View from './EducationGoalChartView';

const mapDispatchToProps = dispatch => ({
  fetchData(clientId, fpId, goalId) {
    dispatch(getGoalsChartList(fpId, clientId, false, goalId));
  },
  setData(clientId, goalId, data) {
    dispatch(receiveData(clientId, data, goalId));
  },
});

const RetirementGoalChart = connect(null, mapDispatchToProps)(View);

export default RetirementGoalChart;
